var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('div',{on:{"click":function($event){return _vm.uppdateraRullgardin()}}},[_c('HeaderField',{key:_vm.stangning})],1),_c('router-view')],1),_c('Footern')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }